import { StylesConfig } from 'react-select';
import { OptionType } from 'components/CustomSelect/types';

const SPREADSHEET_NOTE_REFERENCE_MENU_MIN_WIDTH = '240px';
const SPREADSHEET_NOTE_YEAR_MENU_MIN_WIDTH = '160px';
const SPREADSHEET_NOTE_MENU_MAX_WIDTH = 'min(420px, calc(100vw - 24px))';

export const spreadsheetNoteYearListStyles = (zoomLevel: number): StylesConfig<OptionType, false> => ({
  noOptionsMessage: styles => ({
    ...styles,
    fontSize: `${14 * zoomLevel}px`,
    textAlign: 'right',
  }),
  option: styles => ({
    ...styles,
    fontSize: `${14 * zoomLevel}px`,
    textAlign: 'right',
  }),
  menu: styles => ({
    ...styles,
    left: 0,
    marginTop: 0,
    maxWidth: SPREADSHEET_NOTE_MENU_MAX_WIDTH,
    minWidth: SPREADSHEET_NOTE_YEAR_MENU_MIN_WIDTH,
    right: 'auto',
    top: 0,
    width: 'max-content',
  }),
  menuPortal: styles => ({
    ...styles,
    margin: 0,
  }),
});

export const spreadsheetNoteReferenceListStyles = (zoomLevel: number): StylesConfig<OptionType, false> => ({
  noOptionsMessage: styles => ({
    ...styles,
    fontSize: `${14 * zoomLevel}px`,
    textAlign: 'left',
  }),
  option: styles => ({
    ...styles,
    fontSize: `${14 * zoomLevel}px`,
  }),
  menu: styles => ({
    ...styles,
    left: 0,
    marginTop: 0,
    maxWidth: SPREADSHEET_NOTE_MENU_MAX_WIDTH,
    minWidth: SPREADSHEET_NOTE_REFERENCE_MENU_MIN_WIDTH,
    right: 'auto',
    top: 0,
    width: 'max-content',
  }),
  menuPortal: styles => ({
    ...styles,
    margin: 0,
  }),
});
